import Parameter from '../../Parameter';
import DateRangeValidator from './DateRangeValidator';

import processParameters from '../../FormModel/utils/processParameters';

/** Ensure that we send a datetime string */
const ensureDateTime = (string, isAllDay) => {
  if (string.includes('T')) {
    if (isAllDay) {
      // user just might have toggled isAllDay to true
      return string.replace(/T.*/, 'T00:00:00');
    }
    // user has entered a datetime
    return string;
  }
  // user has entered a date
  return `${string}T00:00:00`;
};

export default class DateRange extends Parameter {
  constructor(parameter) {
    const dateRangeValidator = new DateRangeValidator();
    super(parameter, dateRangeValidator);
    this.params = processParameters(parameter.params, this.broadcast.bind(this));

    dateRangeValidator.registerInputParameters(this.params);
  }

  onChange(name, value) {
    this.params[name].value = value;
    this.validate(); // calls validate of Paremeter which will call validate of DateRangeValidator
  }

  valueChanged() {
    return Object.keys(this.params).filter(key => this.params[key].valueChanged()).length > 0;
  }

  getPayloadValue() {
    if (this.params) {
      const payLoadToAssign = Object.keys(this.params).map(key => {
        if (key === 'isAllDay') {
          return {
            name: this.params[key].name,
            value: this.params[key].checked,
          };
        }
        return {
          name: this.params[key].name,
          value: ensureDateTime(this.params[key].value, this.params.isAllDay.checked),
        };
      });
      return payLoadToAssign;
    }
  }
}
